// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"557745b4","264":"dd5004a8","928":"d606525e"}[chunkId] + ".css";
};